import '../scss/front.scss'

import { initMenu } from './components/menu.js'

const partials = import.meta.webpackContext('../../views/partial', {
  mode: 'eager',
  regExp: /scripts\/_partial\.js$/
})
const views = import.meta.webpackContext('../../views', {
  mode: 'eager',
  regExp: /scripts\/_view\.js$/
})

// Execute all imported modules
const importModules = async (modules) => {
  for (const key of modules.keys()) {
    const module = await modules(key)
    if (module.default) {
      module.default()
    }
  }
}

const initViews = async () => {
  await importModules(views)
  await importModules(partials)
}

window.addEventListener('DOMContentLoaded', () => {
  initViews()
  initMenu()
})
